import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useQueryParam } from 'use-query-params';

import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { useRefetchForStaleData } from 'hooks/useRefetchForStaleData';
import i18n, { loadTranslations } from 'i18n';
import { setItinerariesItemDataAction } from 'store/itinerariesItem';
import { itineraryWithoutEmptyPagesSelector } from 'store/itinerariesItem/selectors';
import axios from 'utils/axios';
import { ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP } from 'utils/itineraries/functions';
import { checkIsWebviewReady } from 'utils/mobileApplication';

import { getLandingForViewMode } from '../../PropertyPortal/functions';

const getItinerariesItemType = (typeQuery) => {
  if (typeQuery === ITINERARIES_ITEM_TYPES.SAMPLE) return ITINERARIES_ITEM_TYPES.SAMPLE;
  if (typeQuery === ITINERARIES_ITEM_TYPES.SAMPLE_LOOKBOOK) return ITINERARIES_ITEM_TYPES.SAMPLE_LOOKBOOK;
  if (typeQuery === ITINERARIES_ITEM_TYPES.LOOKBOOK) return ITINERARIES_ITEM_TYPES.LOOKBOOK;
  return ITINERARIES_ITEM_TYPES.ITINERARY;
};

export function useItineraryPortal() {
  const { id, tail } = useParams();
  const dispatch = useDispatch();
  const itinerary = useSelector(itineraryWithoutEmptyPagesSelector);
  const [typeQuery] = useQueryParam('type');
  const [isError, setIsError] = useState(false);

  const itinerariesItemType = getItinerariesItemType(typeQuery);
  let url = `/${ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[itinerariesItemType]}/${id}`;

  if (tail) {
    url = `/custom_link/${tail}`;
  }

  const { isLoading, error, refetch } = useQuery(
    ['client_portal', id, tail],
    async () => {
      // console.log('TRY TO GET JSON DATA FROM NETWORK');

      const { data } = await axios.get(url);
      const processedData = getLandingForViewMode(data, {
        alwaysHideImageBlocks: localStorage.getItem('pdfPreview') === 'true',
      });

      await loadTranslations(i18n, data?.settings?.language);
      dispatch(setItinerariesItemDataAction(processedData));
      checkIsWebviewReady();

      return data;
    },
    {
      refetchOnWindowFocus: !isError,
    },
  );

  useRefetchForStaleData(refetch);
  useProposalViewed(url);

  useEffect(() => {
    if (error) {
      setIsError(true);
    }
  }, [error]);

  return {
    itinerary,
    isLoading,
    error,
  };
}

export function useRenderingKey() {
  const [key, setKey] = useState(0);
  const { isTabletOrMobile } = useMediaBreakpoints();

  useEffect(() => {
    setKey((val) => val + 1);
  }, [isTabletOrMobile]);

  return key;
}

export function useProposalViewed(url) {
  const [notrack] = useQueryParam('notrack');

  useEffect(() => {
    if (notrack !== '1' && localStorage.getItem('pdfPreview') !== 'true') {
      axios.post(`${url}/view`);
    }
  }, [notrack, url]);
}
